module.exports = __webpack_public_path__ + "img/tianyancha.b58992b0.svg";